import { Entity, stringifyEntityRef } from '@backstage/catalog-model';

export const SUBSCRIPTION_TECHNICAL_CONTACTS_ANNOTATION =
  'tomtom.com/technical-contacts';

const normalizeEntityName = (name: string): string => {
  let cleaned = name
    .trim()
    .toLocaleLowerCase()
    .replace(/[^-a-zA-Z0-9_.]/g, '_')
    .replaceAll(/\s+/g, '_');

  while (cleaned.endsWith('_')) {
    cleaned = cleaned.substring(0, cleaned.length - 1);
  }

  while (cleaned.includes('__')) {
    cleaned = cleaned.replace('__', '_');
  }

  return cleaned;
};

export const getSubscriptionTechnicalContactsFromAnnotation = (
  entity?: Entity,
): string[] => {
  return (
    entity?.metadata.annotations?.[
      SUBSCRIPTION_TECHNICAL_CONTACTS_ANNOTATION
    ] ?? ''
  )
    .split(';')
    .map(email => email.trim())
    .filter(Boolean);
};

export const getSubscriptionTechnicalContactRefs = (
  entity?: Entity,
): string[] => {
  if (!entity) {
    return [];
  }

  const relationRefs = (entity.relations ?? [])
    .filter(relation => relation.type === 'hasTechnicalContact')
    .map(relation => relation.targetRef?.toLocaleLowerCase())
    .filter((targetRef): targetRef is string => Boolean(targetRef));

  if (relationRefs.length > 0) {
    return relationRefs;
  }

  const contacts = getSubscriptionTechnicalContactsFromAnnotation(entity);

  const namespace = entity.metadata.namespace ?? 'default';
  return contacts.map(email =>
    stringifyEntityRef({
      kind: 'User',
      namespace,
      name: normalizeEntityName(email),
    }).toLocaleLowerCase(),
  );
};
